import Vue from 'vue'


import GoBackItem from "@/components/GoBackItem/index.vue"

Vue.component('GoBackItem', GoBackItem)
